'use client';

import { c as _c } from "react/compiler-runtime";
import type { Address, ChainId } from '@morpho-org/blue-sdk';
import { DataList } from '@morpho-org/ui-v6/client';
import { formatters } from '@morpho-org/ui-v6/utils';
import { AddressDataLine } from '@/components/common/DataLine';
import { SubSectionTitle } from '@/components/common/SubSectionTitle';
export interface VaultFeesProps {
  chainId: ChainId;
  performanceFee?: number | null;
  feeRecipient?: Address;
}
const VaultFees = t0 => {
  const $ = _c(12);
  const {
    chainId,
    performanceFee,
    feeRecipient
  } = t0;
  let t1;
  if ($[0] !== performanceFee) {
    t1 = formatters.percent.digits(2).unit("%").default("0").of(performanceFee);
    $[0] = performanceFee;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const formattedPerformanceFee = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SubSectionTitle>Fees</SubSectionTitle>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <DataList.LeftItem label="Performance fee" tooltip="The performance fee is a percentage of the yield generated by the vault, aligning the curator's revenue with the vault's success." />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== formattedPerformanceFee) {
    t4 = <DataList.Column><DataList.Line>{t3}<DataList.RightItem><span className="text-foreground text-xs">{formattedPerformanceFee}</span></DataList.RightItem></DataList.Line></DataList.Column>;
    $[4] = formattedPerformanceFee;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== chainId || $[7] !== feeRecipient) {
    t5 = <DataList.Column><AddressDataLine title="Performance fee recipient" chainId={chainId} tooltipMessage="The address that receives the performance fee from the vault." toastMessage="Fee recipient address copied to clipboard." address={feeRecipient} /></DataList.Column>;
    $[6] = chainId;
    $[7] = feeRecipient;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <div className="gap-2xs flex w-[100%] scroll-mt-[calc(var(--sticky-offset,0px)+16px)] flex-col items-start" id="fees-section">{t2}<DataList.Root fullWidth={true}>{t4}{t5}</DataList.Root></div>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
export default VaultFees;